<template>
    <ob1-popin-modal-visual
        :id="id"
        :aria-labelledby="id"
        :show-close-button="false"
        additional-classes="d-webview-none"
    >
        <template #visual>
            <div class="ob1-modal-img d-webview-none">
                <div class="image-crop">
                    <img
                        :src="visual.src"
                        :alt="visual.alt"
                    >
                </div>
            </div>
        </template>
        <template #content>
            <h4 class="text-dark" v-html="title" />
            <ob1-message-alerte
                v-if="description"
                class="pt-1"
                :type="'info'"
                :is-simple-alerte="false"
                :title="description"
            />


            <div class="d-flex justify-content-center  py-2">
                <div class="d-inline-flex flex-column flex-md-row-reverse text-center">
                    <ob1-boutons
                        class="ms-0 mb-2 ms-md-2 mb-md-0"
                        :label="withDeviceSection.button.label"
                        :is-primary="isSub"
                        :is-secondary="!isSub"
                        :is-button="false"
                        :href="withDeviceSection.button.href"
                        :data-oevent-category="withDeviceSection.button.tmsDTO.tagZone"
                        :data-oevent-action="withDeviceSection.button.tmsDTO.tagName"
                        :data-oevent-label="withDeviceSection.button.href"
                    />
                    <ob1-liens
                        v-if="isSub"
                        class="text-center"
                        :text="withoutDeviceSection.button.label"
                        :href="withoutDeviceSection.button.href"
                        :is-link="true"
                        :data-oevent-category="withoutDeviceSection.button.tmsDTO.tagZone"
                        :data-oevent-action="withoutDeviceSection.button.tmsDTO.tagName"
                        :data-oevent-label="withoutDeviceSection.button.href"
                    />
                    <ob1-boutons
                        v-else
                        :label="withoutDeviceSection.button.label"
                        :href="withoutDeviceSection.button.href"
                        :is-button="false"
                        :is-primary="true"
                        :data-oevent-category="withoutDeviceSection.button.tmsDTO.tagZone"
                        :data-oevent-action="withoutDeviceSection.button.tmsDTO.tagName"
                        :data-oevent-label="withoutDeviceSection.button.href"
                    />
                </div>
            </div>
        </template>
    </ob1-popin-modal-visual>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: false,
            default: "withDevicePopIn"
        },
        title: {
            type: String,
            required: false,
            default: ""
        },
        description: {
            type: String,
            required: false,
            default: ""
        },
        visual: {
            type: Object,
            required: true
        },
        withDeviceSection: {
            type: Object,
            required: true
        },
        withoutDeviceSection: {
            type: Object,
            required: true
        },
        isSub: {
            type: Boolean,
            required: false,
            default: false
        },
    }

}
</script>

<style scoped lang="scss">
@media (min-width: 736px) {
    .image-crop {
        width: 405px;
        overflow: hidden;
        position: relative;
    }

    .image-crop img {
        position: absolute;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
